<script setup>
/* Profilbild eines Nutzerkontos — rein darstellend.
 *
 * Bewusst getrennt von PlayerAvatar.vue: Das dort haengt an einem
 * Spielerdatensatz und bringt die Hochladelogik samt Rechtepruefung mit.
 * Hier geht es um das Konto des Angemeldeten oder um eine Zeile in der
 * Nutzerverwaltung — beides kennt keinen Spieler.
 */

import { computed } from 'vue';
import { initials } from '../domain/format.js';
import { useStoredImage } from '../composables/useStoredImage.js';

const props = defineProps({
  name: { type: String, default: '' },
  /** Pfad im geschuetzten Speicher; der Link wird bei Bedarf signiert. */
  path: { type: String, default: '' },
  size: { type: Number, default: 32 },
});

const { url } = useStoredImage(() => props.path);
const label = computed(() => initials(props.name) || '?');
</script>

<template>
  <div
    class="avatar-box user-avatar"
    :class="{ 'has-photo': !!url }"
    :style="{ width: size + 'px', height: size + 'px' }"
    :title="name || undefined"
  >
    <img v-if="url" :src="url" alt="" />
    <span v-else class="avatar-fallback">{{ label }}</span>
  </div>
</template>

<style scoped>
.user-avatar {
  flex: none;
}
</style>
